import { ICheckpointOutputDto, ITripOutputDto } from './trip-output-dto.interface';

export type ICheckpointHistoricOutputDto = ICheckpointOutputDto;

export interface ITripHistoricOutputDto extends ITripOutputDto {
    originalId: string;
    checkpoints: ICheckpointHistoricOutputDto[];
}
